<template>
  <div>
    <div class="input-group">
      <div class="form-floating">
        <input
            @input="handleInput"
            :type="type"
            class="form-control"
            :id="property"
            :value="value"
            :class="{'is-invalid': error }"
            :disabled="disabled"
        >

        <label :for="property">{{ name }}<span class="text-danger" v-if="isRequired">*</span></label>
      </div>
      <slot name="resetPassword">
        <button class="btn btn-outline-secondary" type="button" id="button-addon2">Reset</button>
      </slot>
    </div>  
    <div class="mb-3">
      <message-error :code="errorCode" :hasError="error"/>
    </div>  
  </div>


</template>

<script>
import MessageError from '@/core/components/MessageError.vue'

export default {
  name: 'TextField',
  components: { MessageError },
  props: {
    value:{}, 
    property:{}, 
    name:{}, 
    type:{ default: 'password' }, 
    error:{}, 
    disabled:{ default: false}, 
    isRequired: {},
    errorCode: { type: String }
  },
  methods: {
    handleInput (e) {
      this.$emit('input', e.target.value)
    }
  }
}
</script>

<style scoped>
input{
  border-radius: 0 !important;
}
</style>
